<div class="container-filter">
  <input type="text"
    class="input-text"
    [(ngModel)]="filterText"
    [placeholder]="'search_for' | translate" />

  <button
    [attr.aria-label]="'edit' | translate"
    matIconButton
    (click)="onInvertSort()"
    color="accent">
        <mat-icon svgIcon="Icons_SORT" />
  </button>
</div>

@let filterdLexiconStations = filteredLexiconStationsSignal();
@if (filterdLexiconStations?.length > 0) {
  @for (entry of filterdLexiconStations; track entry) {
    <button
      matButton="filled"
      color="accent"
      class="container-item button-rounded"
      (click)="navigateToEntry(entry.id)">
      <div class="container-text">
        <div class="text-title">
          {{ entry.title[translate.getCurrentLang()] }}
        </div>
      </div>
    </button>
  }
} @else {
  <p>{{'search_no_entries_found' | translate}}</p>
}